import { addDays, isSameDay, startOfDay, isBefore } from 'date-fns';
import React, { useMemo } from 'react';
import { IconButton, KeyboardDatePicker, TextButton } from 'seagull';
import { ArrowHead } from 'seagull/icons';
import styles from "./InvoiceNavigator.module.scss";
import { useIoContext } from "../../../../contexts";
import { getMaxFutureInvoiceDate } from "../../../../business-logic/billingLogic";
import findLast from 'lodash/findLast';

function NavigationButtons(props) {
  const {
    options,
    value,
    onChange
  } = props;
  const is1stSelected = useMemo(() => isSameDay(value, options[0]), [value, options]);
  const nextOption = useMemo(() => options.find(opt => isBefore(value, opt)), [value, options]);
  const prevOption = useMemo(() => findLast(options, opt => isBefore(opt, value)), [value, options]);
  const prevDisabled = !prevOption;
  const nextDisabled = !nextOption;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.buttons
  }, /*#__PURE__*/React.createElement(IconButton, {
    noPadding: true,
    disabled: prevDisabled,
    tooltip: {
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": "to-prev-tooltip"
      }, prevDisabled ? 'No earlier invoices are available' : 'Previous invoice'),
      placement: 'top'
    },
    "data-testid": "to-prev-invoice",
    onClick: () => prevOption && onChange(prevOption)
  }, /*#__PURE__*/React.createElement(ArrowHead, {
    direction: "left"
  })), /*#__PURE__*/React.createElement(IconButton, {
    noPadding: true,
    disabled: nextDisabled,
    tooltip: {
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": "to-next-tooltip"
      }, nextDisabled ? 'No later invoices are available' : 'Next invoice'),
      placement: 'top'
    },
    "data-testid": "to-next-invoice",
    onClick: () => nextOption && onChange(nextOption)
  }, /*#__PURE__*/React.createElement(ArrowHead, {
    direction: "right"
  })), !is1stSelected && /*#__PURE__*/React.createElement(TextButton, {
    underline: "none",
    "data-testid": "to-upcoming-invoice",
    onClick: () => onChange(options[0])
  }, "Go to upcoming invoice"));
}

export default function InvoiceNavigator(props) {
  const {
    value,
    options,
    onChange
  } = props;
  const {
    getNow
  } = useIoContext();
  const minDate = useMemo(() => startOfDay(addDays(getNow(), 1)), []);
  const maxDate = useMemo(() => getMaxFutureInvoiceDate(getNow()), []);

  function isDayInOptions(day) {
    return !!day && options.some(opt => isSameDay(opt, day));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    size: "small",
    disableKeyboardInput: true,
    disableErrors: true,
    label: "Invoice to manage",
    "data-testid": "invoice-picker",
    value: value,
    minDate: minDate,
    maxDate: maxDate,
    highlightDay: isDayInOptions,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }

      onChange.toString = function () {
        return _onChange.toString();
      };

      return onChange;
    }(date => onChange(date || null))
  }), value && /*#__PURE__*/React.createElement(NavigationButtons, {
    options: options,
    value: value,
    onChange: onChange
  }));
}